import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import FollowRequests from "./FollowRequests";
import { API_BASE_URL } from "./config";

const Profile = () => {
  const [profilePic, setProfilePic] = useState(null);
  const [fullName, setFullName] = useState("");
  const [displayUsername, setDisplayUsername] = useState("");
  const [tagline, setTagline] = useState("");
  const [bio, setBio] = useState("");
  const [city, setCity] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [age, setAge] = useState("");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    // Fetch the profile data on mount
    const fetchProfile = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/profile`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        setProfilePic(res.data.profilePic);
        setFullName(res.data.fullName || "");
        setDisplayUsername(res.data.displayUsername || "");
        setTagline(res.data.tagline);
        setBio(res.data.bio);
        setCity(res.data.city || "");
        setZipCode(res.data.zipCode || "");
        setAge(res.data.age || "");
        setLoading(false);
      } catch (err) {
        console.error("Error fetching profile", err);
        setLoading(false);
      }
    };

    fetchProfile();
  }, []);

  if (loading) {
    return (
      <div className="container mt-4">
        <div className="text-center">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container mt-4">
      <div className="row">
        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center mb-4">
                <h2 className="card-title mb-0">My Profile</h2>
                <button 
                  className="btn btn-primary"
                  onClick={() => navigate("/edit-profile")}
                >
                  Edit Profile
                </button>
              </div>
              
              <div className="text-center mb-4">
                {profilePic ? (
                  <img
                    src={`${API_BASE_URL}/${profilePic}`}
                    alt="Profile"
                    style={{ 
                      width: "150px", 
                      height: "150px", 
                      borderRadius: "50%",
                      objectFit: "cover"
                    }}
                  />
                ) : (
                  <div 
                    style={{ 
                      width: "150px", 
                      height: "150px", 
                      borderRadius: "50%",
                      backgroundColor: "#e9ecef",
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center"
                    }}
                  >
                    <span className="text-muted">No Photo</span>
                  </div>
                )}
              </div>

              <div className="mb-3">
                <h5>Full Name</h5>
                <p className="text-muted">{fullName || "Name not set"}</p>
              </div>

              <div className="mb-3">
                <h5>Username</h5>
                <p className="text-muted">{displayUsername ? `@${displayUsername}` : "No username set"}</p>
              </div>

              <div className="mb-3">
                <h5>Tagline</h5>
                <p className="text-muted">{tagline || "No tagline set"}</p>
              </div>

              <div className="mb-3">
                <h5>Bio</h5>
                <p className="text-muted">{bio || "No bio added yet"}</p>
              </div>

              <div className="mb-3">
                <h5>Age</h5>
                <p className="text-muted">{age || "Age not specified"}</p>
              </div>

              <div className="mb-3">
                <h5>Location</h5>
                <p className="text-muted">
                  {city && zipCode ? `${city}, ${zipCode}` : city || zipCode || "Location not specified"}
                </p>
              </div>

              <div className="d-grid">
                <button 
                  className="btn btn-outline-primary"
                  onClick={() => navigate("/home")}
                >
                  Back to Home
                </button>
              </div>
            </div>
          </div>
        </div>
        
        <div className="col-md-6">
          <FollowRequests />
        </div>
      </div>
    </div>
  );
};

export default Profile;
